import { createEntityCollectionStore } from '@recruitee/ngrx';

import { FieldMapping } from '../../../types';

const { actions, namespace, selectors, reducer } =
  createEntityCollectionStore<FieldMapping>()('FieldMapping');

export {
  actions as FieldMappingActions,
  namespace as FieldMappingNamespace,
  reducer as FieldMappingReducer,
  selectors as FieldMappingSelectors,
};
